export default {
  title: {
    sk: 'Newsletter',
    en: 'Newsletter',
  },
  description: {
    sk:
      'Každé dva týždne vyberáme ten najlepší obsah o zákazníckej skúsenosti a user-centrickom dizajne.',
    en:
      'Every two weeks we handpick the best content about customer experience and user-centered design.',
  },
  emailPlaceholder: {
    sk: 'Váš e-mail',
    en: 'Your e-mail address',
  },
  buttonLabel: {
    sk: 'Odoberať',
    en: 'Subscribe',
  },
};



// WEBPACK FOOTER //
// ./src/modules/NewsletterForm/messages.js